import { gql } from '@apollo/client';

export const UPDATE_LEGALS = gql`
  mutation ($id: String!, $legals: [WarningInput]) {
    clientSetup(id: $id, legals: $legals)
  }
`;
